// import { Grid } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import WSDashboardCard from "../../../Components/CardListing/WSDashboardCard";
// import WSFilterButtonGroup from "../../../Components/Filter/WSFilterButtonGroup";
// import WSButton from "../../../Components/Button/WSButton";
// import WSDataGridNew, {
//   IColumns,
// } from "../../../Components/DataGrid/WSDataGridNew";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import AddIcon from "@mui/icons-material/Add";
// import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import { IHeaderRows } from "../../../Components/Filter/WSHeaderFilter";
// import { useNavigate } from "react-router-dom";
// import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import PaymentDetailsCard from "./PaymentDetails";
// import PaymentDetails from "./PaymentDetails";
// export const PaymentList: React.FC<any> = React.memo((props) => {
// const [open, setOpen] = useState(false);
  
// const navigate = useNavigate()
//   useEffect(() => { updateMainHeader('Payments'); }, [])
  
  
//      breadCrumbsStore.updateBreadCrumbs([
//                 { 'Payments': 'payments/list' },
//     ]);
//   const columns: IColumns[] = [
//     {
//       header: "Transaction ID ",
//       fieldName: "",
//       type: "default",
//       // sortable: true
//     },
//     {
//       header: "Order ID",
//       fieldName: "mode",
//       type: "default",
//     },
//     {
//       header: "Patient Name",
//       fieldName: "price",
//       type: "default",
//     },
//     {
//       header: "Amount",
//       fieldName: "price",
//       type: "default",
//     },
//     {
//       header: "Type",
//       fieldName: "status",
//       type: "status",
//     },
//     {
//       header: "Cash/UPI",
//       fieldName: "status",
//       type: "status",
//     },
    
//    {
//       header: "Order Date",
//       fieldName: "status",
//       type: "status",
//     },
//     {
//       header: "Status",
//       fieldName: "status",
//       type: "status",
//     },
    
//     {
//       header: "Actions",
//       fieldName: "actions",
//       type: "action",
//       actions: ["Edit"].filter(Boolean),
//       // actionCallback: (action, row) => handleAction(action, row),
//       // hideSelectedActions: {
//       //     fieldToHide: [
//       //         {
//       //             field: 'status',
//       //             hideValue: ['Incomplete'],
//       //             hideActions: ['Edit']
//       //         },
//       //         // {
//       //         //     field: 'profileStatus',
//       //         //     hideValue: ['Approved'],
//       //         //     hideActions: ['Approve']
//       //         // }
//       //     ]
//       // }
//     },
//   ];
//   const filterRows: IHeaderRows[] = [
   
  
//     {
//       label: "Status",
//       fieldName: "IsProfileComplete",
//       type: "dropdown",
//       options: [
//         { label: "Completed", value: "true" },
//         { label: "Incomplete", value: "false" },
//       ],
//       operator: "eq",
//       rowDivision: 3,
//     },
//      {
//       label: "By Date",
//       fieldName: "",
//       type: "date",
//       operator: "like",
//       rowDivision: 6,
//     },
//   ];
// const handleClick = async () => {
//     navigate('/payment-details')
//   };
  
//   return (
//     <>
//       <Grid container spacing={2}>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Total Payments Received"
//             value="400"
//             percentage="+2.5%"
//             bottomIcon={<TrendingUpIcon />}
//             icon={<ShoppingCartIcon sx={{ color: "#098963" }} />}
//             onClick={() => console.log("Card clicked")}
//           />
//         </Grid>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Today Payments"
//             value="1000"
//             percentage="+2.5%"
//             bottomIcon={<TrendingUpIcon />}
//             icon={<WSIcons.InStockIcon sx={{ color: "#098963" }} />}
//             onClick={() => console.log("Card clicked")}
//           />
//         </Grid>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Refunded Amount"
//             value="10000"
//             percentage="+2.5%"
//             bottomIcon={<TrendingUpIcon />}
//             icon={<WSIcons.OutOfStockIcon sx={{ color: "red" }} />}
//             onClick={() => console.log("Card clicked")}
//           />
//         </Grid>
       
//   <Grid item sm={3} display="flex" justifyContent={"flex-end"}>
//           <WSButton
//             id="btnAddNewProduct"
//             label="View"
//             startIcon={<AddIcon />}
//             onClick={() => setOpen(true)}
//             sx={{
//               borderRadius: "999px", // pill shape
//               backgroundColor: "#098963!important", // green background
//               textTransform: "none", // prevent uppercase
//               fontWeight: 500,
//               height: "35px!important",
//               fontSize: "0.875rem!important",
//               paddingX: 3,
//               paddingY: 1,
//               "&:hover": {
//                 backgroundColor: "#087654!important",
//               },
//             }}
//           />
//         </Grid>
//       </Grid>
// <PaymentDetails open={open} onClose={() => setOpen(false)} />
//       <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
//         {
//           <Grid item sm={12}>
//             <WSDataGridNew
//               columns={columns}
//               id="paymentGrid"
//               title=""
//               exportCsv={true}
//               filterFields={filterRows}
//               addButton={{ label: "New", color: "secondary" }}
//               searchBox={{ fieldName: "name" }}
//               gridHeaderSx={{
//                 backgroundColor: "whitesmoke",
//                 border: "1px solid whitesmoke",
//               }}
//             />
//           </Grid>
//         }
//       </Grid>
//     </>
//   );
// });



import { Grid } from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import WSDashboardCard from "../../../Components/CardListing/WSDashboardCard";
import WSButton from "../../../Components/Button/WSButton";
import WSDataGridNew, {
  IColumns,
} from "../../../Components/DataGrid/WSDataGridNew";
import { WSIcons } from "../../../commonFunctions/iIcons";
import AddIcon from "@mui/icons-material/Add";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { useNavigate } from "react-router-dom";
import { updateMainHeader, getLocalValue, LoacalVariables } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import PaymentDetails from "./PaymentDetails";
import http from "../../../commonFunctions/httpClient";

interface Payment {
  id: string;
  transactionId: string;
  orderId: string;
  patientName: string;
  amount: number;
  type: string;
  paymentMethod: string;
  orderDate: string;
  status: string;
}

interface PaymentSummary {
  totalPaymentReceived: number;
  todayPayment: number;
  refundAmount: number;
}

export const PaymentList: React.FC<any> = React.memo((props) => {
  const [open, setOpen] = useState(false);
  const [selectedPaymentId, setSelectedPaymentId] = useState<string | null>(null);
  const [vendorId, setVendorId] = useState<string>("");
  const [payments, setPayments] = useState<Payment[]>([]);
  const [summary, setSummary] = useState<PaymentSummary>({
    totalPaymentReceived: 0,
    todayPayment: 0,
    refundAmount: 0
  });
  const [loading, setLoading] = useState(true);
  
  const navigate = useNavigate();

  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId);
    if (userId) {
      console.log('🚀 Loading vendorId:', userId);
      setVendorId(userId);
    }
  }, []);

  const fetchPayments = useCallback(async () => {
    if (!vendorId) {
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      console.log("📡 FETCHING PAYMENTS:", vendorId);
      const response: any = await http.get(`pharmacy/PhPayment/ByVendor/${vendorId}`);
      console.log('✅ FULL API RESPONSE:', response);
      
      if (response?.success && Array.isArray(response.data)) {
        const data = response.data.map((payment: any) => ({
          id: payment.paymentId,
          transactionId: payment.transactionId,
          orderId: payment.orderId,
          patientName: payment.patientName,
          amount: payment.amount,
          type: payment.type,
          paymentMethod: payment.paymentMethod,
          orderDate: payment.orderDate,
          status: payment.status
        }));
        setPayments(data);
      }
    } catch (error: any) {
      console.error("💥 API ERROR:", error);
      setPayments([]);
    } finally {
      setLoading(false);
    }
  }, [vendorId]);

  const fetchPaymentSummary = useCallback(async () => {
    if (!vendorId) return;
    try {
      const response: any = await http.get(`pharmacy/PhPayment/payment-summary/${vendorId}`);
      if (response?.success && response?.data) {
        setSummary({
          totalPaymentReceived: response.data.totalPaymentReceived || 0,
          todayPayment: response.data.todayPayment || 0,
          refundAmount: response.data.refundAmount || 0
        });
      }
    } catch (error: any) {
      console.error("💥 Summary Error:", error);
    }
  }, [vendorId]);

  useEffect(() => {
    if (vendorId) {
      fetchPayments();
      fetchPaymentSummary();
    }
  }, [vendorId, fetchPayments, fetchPaymentSummary]);

  useEffect(() => { 
    updateMainHeader('Payments'); 
  }, []);

  useEffect(() => {
    breadCrumbsStore.updateBreadCrumbs([
      { 'Payments': 'payments/list' },
    ]);
  }, []);

  const handleAction = useCallback((action: string, row: Payment) => {
    console.log("🔧 ACTION:", action, "ROW:", row);
    if (action === "View") {
      setSelectedPaymentId(row.id);
      setOpen(true);
    }
  }, []);

  const handleClick = async () => {
    navigate('/payment-details');
  };

  const handleCloseModal = () => {
    setOpen(false);
    setSelectedPaymentId(null);
  };

  if (loading) {
    return (
      <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
        <Grid item sm={12} display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <div>Loading payments...</div>
        </Grid>
      </Grid>
    );
  }

  const columns: IColumns[] = [
    { header: "Transaction ID", fieldName: "transactionId", type: "default" },
    { header: "Order ID", fieldName: "orderId", type: "default" },
    { header: "Patient Name", fieldName: "patientName", type: "default" },
    { header: "Amount", fieldName: "amount", type: "default" },
    { header: "Type", fieldName: "type", type: "default" },
    { header: "Payment Method", fieldName: "paymentMethod", type: "status" },
    { header: "Order Date", fieldName: "orderDate", type: "date" },
    { header: "Status", fieldName: "status", type: "status" },
    {
      header: "Actions",
      fieldName: "id",
      type: "action",
      actions: ["View"],
      actionCallback: (action, row) => handleAction(action, row as Payment),
    },
  ];

  return (
    <>
      <Grid container spacing={2}>
        <Grid item sm={3}>
          <WSDashboardCard
            title="Total Payments Received"
            value={summary.totalPaymentReceived.toString()}
            percentage=""
            bottomIcon={<TrendingUpIcon />}
            icon={<ShoppingCartIcon sx={{ color: "#098963" }} />}
            onClick={() => console.log("Card clicked")}
          />
        </Grid>
        <Grid item sm={3}>
          <WSDashboardCard
            title="Today Payments"
            value={summary.todayPayment.toString()}
            percentage=""
            bottomIcon={<TrendingUpIcon />}
            icon={<WSIcons.InStockIcon sx={{ color: "#098963" }} />}
            onClick={() => console.log("Card clicked")}
          />
        </Grid>
        <Grid item sm={3}>
          <WSDashboardCard
            title="Refunded Amount"
            value={summary.refundAmount.toString()}
            percentage=""
            bottomIcon={<TrendingUpIcon />}
            icon={<WSIcons.OutOfStockIcon sx={{ color: "red" }} />}
            onClick={() => console.log("Card clicked")}
          />
        </Grid>
        {/* <Grid item sm={3} display="flex" justifyContent="flex-end">
          <WSButton
            id="btnViewPayments"
            label="View Details"
            startIcon={<AddIcon />}
            onClick={handleClick}
            sx={{
              borderRadius: "999px",
              backgroundColor: "#098963!important",
              textTransform: "none",
              fontWeight: 500,
              height: "35px!important",
              fontSize: "0.875rem!important",
              paddingX: 3,
              paddingY: 1,
              "&:hover": {
                backgroundColor: "#087654!important",
              },
            }}
          />
        </Grid> */}
      </Grid>

      <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
        <Grid item sm={12}>
          <WSDataGridNew
            columns={columns}
            id="paymentGrid"
            title={`Payments (${payments.length})`}
            exportCsv={true}
            data={payments}
            filterFields={[]}
            searchBox={{ fieldName: "transactionId" }}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>
      </Grid>

      <PaymentDetails 
        open={open} 
        onClose={handleCloseModal}
        paymentId={selectedPaymentId || undefined}
      />
    </>
  );
});

export default PaymentList;
